export type BffTransportErrorCode = 'offline';

export class BffTransportError extends Error {
  public constructor(
    public readonly code: BffTransportErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'BffTransportError';
  }
}